export const yearColor = {
    2020: "#FFFDFD",
    2021: "#9F7078",
    2022: "#A3B5C3"
}

export const districtColor = {
    "Açores": "#7EA2AA",
    "Aveiro": "#8BE8CB",
    "Beja": "#48A9A6",
    "Braga": "#D9C5B2",
    "Castelo Branco": "#D1D1D1",
    "Coimbra": "#E63946",
    "Evora": "#D64933",
    "Faro": "#EDD94C",
    "Guarda": "#DD7373",
    "Leiria": "#ED9390",
    "Lisboa": "#E0CA3C",
    "Madeira": "#563F1B",
    "Portalegre": "#F374AE",
    "Porto": "#FFFFFC",
    "Santarém": "#A3333D",
    "Setúbal": "#C4D6B0",
    "Viana do Castelo": "#A0AF84",
    "Vila Real": "#9CA3DB",
}

const districtAbbreviations = {
    "Viana do Castelo": "V. do Castelo",
    "Castelo Branco": "C. Branco"
}

export function getDistrictAbbreviation(district) {
    if (districtAbbreviations.hasOwnProperty(district)) {
        return districtAbbreviations[district];
    }
    return district;
}

export const backgroundColor = "#164F63";
export const lineAndTextColor = "#FFFDFD";

export const fieldSpotsPerYearChartTitle = "Distribuição das vagas preenchidas por ano";
export const fieldSpotsPerDistrictChartTitle = "Distribuição das vagas preenchidas por distrito";
export const lastFieldSpotsChartTitle = "Últimas vagas preenchidas por ano"
